module.exports = __webpack_public_path__ + "img/111.01c1a8df.png";